import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../AuthProvider";
import { useVenue } from "../VenueProvider";
import { Heading } from "../heading";
import { Text } from "../text";
import {
  QuestionMarkCircleIcon,
  PaperAirplaneIcon,
} from "@heroicons/react/20/solid";
import SupportTicketForm from "./SupportTicketForm";
import UserTickets from "./UserTickets";
import AdminTickets from "./AdminTickets";

const ACCENT = "#1b4d2e";

const Support = () => {
  const { userInfo, loading } = useAuth();
  const { venueFeatures } = useVenue();
  const [ticketsKey, setTicketsKey] = useState(0);

  if (loading) return <div>Cargando...</div>;
  if (!userInfo) return <div>No autorizado</div>;

  if (userInfo.role === "admin") {
    return <AdminTickets />;
  }

  // Owner or other user
  return (
    <div className="mx-auto max-w-3xl">
      <div className="flex items-center gap-3 mb-1">
        <QuestionMarkCircleIcon className="h-6 w-6" style={{ color: ACCENT }} />
        <Heading level={1}>Ayuda</Heading>
      </div>
      <Text className="mb-8">
        ¿Tienes alguna duda o problema? Envíanos un ticket y te responderemos lo
        antes posible.
      </Text>

      <div className="space-y-10">
        {venueFeatures?.telegram === true && (
          <div className="rounded-xl border border-zinc-200 dark:border-zinc-700/60 bg-white dark:bg-zinc-800/50 p-4 shadow-sm">
            <div className="flex items-center gap-2 mb-1">
              <PaperAirplaneIcon className="h-5 w-5" style={{ color: ACCENT }} />
              <h2 className="text-base font-semibold text-zinc-900 dark:text-white">
                Bot de Telegram (beta)
              </h2>
            </div>
            <p className="text-sm text-zinc-600 dark:text-zinc-300">
              Tu venue tiene habilitado el bot de Telegram: vincula un grupo con
              tu equipo y consulta disponibilidad, leads y saldos desde el chat.
              El tutorial de conexión y los permisos por grupo están en{" "}
              <Link
                to="/dashboard/config"
                className="font-medium underline"
                style={{ color: ACCENT }}
              >
                Configuración → Telegram
              </Link>
              . Dentro del grupo, escribe /ayuda para ver lo que el bot puede
              hacer.
            </p>
          </div>
        )}
        <SupportTicketForm
          onTicketSubmitted={() => setTicketsKey((k) => k + 1)}
        />
        <UserTickets key={ticketsKey} />
      </div>
    </div>
  );
};

export default Support;
